module.exports = __webpack_public_path__ + "static/media/scroll3_5.e80bcde7.png";